import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { HttpHeadersService } from '../http-headers/http-headers.service';
import {
  DbResponseProject,
  DbResponseProjectsApiResponse,
  PatchResponseProjectsRequestBody,
  PostResponseProjectsRequestBody,
  PutResponseProjectsRequestBody,
  PutResponseProjectsResponse,
  ResponseProject,
  ResponseProjectDetail,
  DbResponseProjectDetail,
  ResponseProjects,
} from '../../../models/response-project';

@Injectable({
  providedIn: 'root',
})
export class ApiResponseProjectsService {
  constructor(
    private http: HttpClient,
    private httpHeadersService: HttpHeadersService
  ) {}

  private url = `${environment.explainApiUrl}response_projects`;

  getById(id: string): Observable<ResponseProjectDetail> {
    return this.http.get<DbResponseProjectDetail>(`${this.url}?id=${id}`, this.httpHeadersService.httpHeaders).pipe(
      map(res => ({
        id: String(res.id),
        name: res.name,
        user_id: res.user_id,
        user_instructions: res.user_instructions ?? null,
        created_at: res.created_at,
        updated_at: res.updated_at,
        is_active: res.is_active,
      }))
    );
  }

  searchResponseProjects(body: PostResponseProjectsRequestBody): Observable<ResponseProjects> {
    return this.http.post<DbResponseProjectsApiResponse>(this.url, body, this.httpHeadersService.httpHeaders).pipe(
      map(res => ({
        data: res.data.map((item: DbResponseProject) => ({
          id: String(item.id),
          name: item.name,
          is_active: item.is_active,
        })),
        pagination: res.pagination,
      }))
    );
  }

  createResponseProject(body: PutResponseProjectsRequestBody): Observable<ResponseProject> {
    return this.http.put<PutResponseProjectsResponse>(this.url, body, this.httpHeadersService.httpHeaders).pipe(
      map(res => ({
        id: String(res.response_project_id),
        name: body.name,
      }))
    );
  }

  updateResponseProject(body: PatchResponseProjectsRequestBody): Observable<ResponseProjectDetail> {
    return this.http.patch<DbResponseProjectDetail>(this.url, body, this.httpHeadersService.httpHeaders).pipe(
      map(res => ({
        id: String(res.id),
        name: res.name,
        user_id: res.user_id,
        user_instructions: res.user_instructions ?? null,
        created_at: res.created_at,
        updated_at: res.updated_at,
        is_active: res.is_active,
      }))
    );
  }

  deleteResponseProject(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}?id=${id}`, this.httpHeadersService.httpHeaders);
  }
}
